<template>
  <div id="app" v-if="!loading">
    <navigation />
    <router-view :key="$route.fullPath" />
  </div>
  <div v-else class="loader">
    <fulfilling-square-spinner :animation-duration="1000" :size="40" :color="'#5a754d'" />
  </div>
</template>

<script>
import navigation from "@/components/common/Navigation";
import { FulfillingSquareSpinner } from "epic-spinners";

export default {
  components: {
    navigation,
    FulfillingSquareSpinner
  },
  computed: {
    loading() {
      return this.$store.getters.loadingState;
    }
  },
  beforeCreate() {
    this.$store.dispatch("init");
  },
  created () {
    console.log("version 1.2 loaded");
  },
};
</script>

<style lang="scss">
@import "@/assets/style/main.scss";
</style>
